import { Accordion as AccordionPrimitive } from "@base-ui/react/accordion";

import { cn, cnState } from "@beweegbaas/ui/lib/utils";
import { IconChevronDown, IconChevronUp } from "@tabler/icons-react";

function Accordion({ className, ...props }: AccordionPrimitive.Root.Props) {
  return (
    <AccordionPrimitive.Root
      data-slot="accordion"
      className={cnState("flex w-full flex-col", className)}
      {...props}
    />
  );
}

function AccordionItem({ className, ...props }: AccordionPrimitive.Item.Props) {
  return (
    <AccordionPrimitive.Item
      data-slot="accordion-item"
      className={cnState("spring-bounce-60 spring-duration duration-100", className)}
      {...props}
    />
  );
}

function AccordionTrigger({ className, children, ...props }: AccordionPrimitive.Trigger.Props) {
  return (
    <AccordionPrimitive.Header className="m-0 flex">
      <AccordionPrimitive.Trigger
        data-slot="accordion-trigger"
        className={cnState(
          `**:data-[slot=accordion-trigger-icon]:text-muted-foreground group/accordion-trigger
          relative flex flex-1 items-start justify-between
          rounded-md py-4 text-left text-base font-medium transition-all
          duration-100 hover:underline disabled:pointer-events-none
          disabled:opacity-50 **:data-[slot=accordion-trigger-icon]:ml-auto
          **:data-[slot=accordion-trigger-icon]:size-4`,
          className,
        )}
        {...props}
      >
        {children}
        <IconChevronDown
          data-slot="accordion-trigger-icon"
          className="pointer-events-none shrink-0
            group-data-panel-open/accordion-trigger:hidden"
        />
        <IconChevronUp
          data-slot="accordion-trigger-icon"
          className="pointer-events-none hidden shrink-0
            group-data-panel-open/accordion-trigger:inline"
        />
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  );
}

function AccordionContent({ className, children, ...props }: AccordionPrimitive.Panel.Props) {
  return (
    <AccordionPrimitive.Panel
      data-slot="accordion-content"
      className="h-(--accordion-panel-height) overflow-hidden
        transition-[height] duration-200 ease-out data-ending-style:h-0
        data-starting-style:h-0"
      {...props}
    >
      <div
        className={cn(
          `[&_a]:hover:text-foreground pt-0 pb-4 [&_a]:underline
          [&_a]:underline-offset-3 [&_p:not(:last-child)]:mb-4`,
          className,
        )}
      >
        {children}
      </div>
    </AccordionPrimitive.Panel>
  );
}

// Export AccordionPrimitive for advanced use cases
export { Accordion, AccordionContent, AccordionItem, AccordionPrimitive, AccordionTrigger };
